import { render, staticRenderFns } from "./PerformanceHistorical.vue?vue&type=template&id=5175324f&scoped=true&"
import script from "./PerformanceHistorical.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PerformanceHistorical.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PerformanceHistorical.vue?vue&type=style&index=0&id=5175324f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5175324f",
  null
  
)

export default component.exports